import { useReducedMotion } from 'motion/react';
import { useEffect, useState } from 'react';

/** 0 → value in 1.5 s (NEWS-08). */
export const COUNT_MS = 1500;

/**
 * A number of the slide counting up from 0 (ease-out), after `delayMs` (the
 * title goes first); the final value at once under reduced motion
 * (NEWS-09). Leaving the slide cancels it.
 */
export function CountUp({
  value,
  format,
  delayMs = 700,
}: {
  value: number;
  format: (value: number) => string;
  delayMs?: number;
}) {
  const reduceMotion = useReducedMotion() ?? false;
  const [counted, setCounted] = useState(0);

  useEffect(() => {
    if (reduceMotion) return;
    setCounted(0);
    let frame = 0;
    let start: number | null = null;
    const step = (now: number) => {
      start ??= now;
      const progress = Math.min(1, (now - start) / COUNT_MS);
      setCounted(progress === 1 ? value : value * (1 - (1 - progress) ** 4));
      if (progress < 1) frame = requestAnimationFrame(step);
    };
    const timer = setTimeout(() => {
      frame = requestAnimationFrame(step);
    }, delayMs);
    return () => {
      clearTimeout(timer);
      cancelAnimationFrame(frame);
    };
  }, [value, delayMs, reduceMotion]);

  return (
    <span className="tabular-nums">
      {format(reduceMotion ? value : counted)}
    </span>
  );
}
